
import { request } from '@/config/request/interceptors'
interface State {
  loading: boolean
  reqingNum: number
  editing: boolean
}

export default {
  namespaced: true,
  state: {
    loading: false,
    reqingNum: 0,
    editing: false,
    renderSidebar: true,
    onLogin: null,
    loginPanel: 'login',
    toCreateShop: false,
    setupChangePWD: 0,
    memberDialog: false,
    newMemberActivity: false,
    d2dLoading: false, // D2D加载状态
    // 店铺补货计划是否开启
    shopReplenishInfo: {
      // 是否开启智能补货计划 0:否 1:是
      smartReplenishFlag: 0,
      replenishTimeList: []
    },
    // 店铺是否支持  日本采购商品
    isJpPurchase: false
  },
  getters: {
    reqLoading(state: State): boolean {
      return state.reqingNum > 0
    }
  },
  mutations: {},
  actions: {
    setToCreateShop(
      {
        commit
      }: { commit: any },
      toCreateShop: boolean
    ) {
      commit('toCreateShop', toCreateShop)
    },
    async setShopReplenishInfo(
      {
        commit
      }: { commit: any }
    ) {
      const res = await request.customer.customer.shopGet({})
      commit('shopReplenishInfo', res.data)
    },
    async setJpPurchase(
      {
        commit,
        rootState
      }: { commit: any, rootState: any }
    ) {
      const res = await request.customer.shop.supportJpPurchase({
        superCustomerId: rootState.route.user.superCustomerId
      })
      commit('isJpPurchase', res.data)
    }
  }
}
